/**
 *
 * @module subscriptionExpiryType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionExpiryType
 * @type {Object}
 *
 * @property {String} UNKNOWN
 * @property {String} EXPIRY
 * @property {String} NO_EXPIRY
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionExpiryType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    UNKNOWN: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    EXPIRY: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    NO_EXPIRY: null
});



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionExpiryType.js